import React, { FC, useMemo, useState } from 'react'
import { Flex, VStack, Image } from '@chakra-ui/react'
import { Button } from '../../components'
import { StarIcon } from '@chakra-ui/icons'
import { cardImageMap } from '../../state/interfaces'

export interface SelectProps {
  onChange?: (values: string[]) => void
  grandImage?: string
}

export const StarsReview: FC<SelectProps> = ({ onChange, grandImage }) => {
  const [rating, setRating] = useState(0)
  const [hover, setHover] = useState(0)
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  return (
    <VStack>
      <Flex marginY={8}>
        {[...Array(5)].map((star, index) => {
          index += 1
          return (
            <Button
              type="button"
              key={index}
              paddingX={2}
              role={'button'}
              border="0"
              _hover={{ backgroundColor: 'transparent' }}
              _active={{ backgroundColor: 'transparent' }}
              onFocus={() => setRating(index)}
              onClick={() => {
                onChange && onChange([index.toString()])
              }}
              onMouseEnter={() => setHover(index)}
              onMouseLeave={() => setHover(rating)}
            >
              <StarIcon
                color={index <= (hover || rating) ? 'error' : 'gray'}
                fontSize={40}
                _hover={{ color: 'error' }}
              />
            </Button>
          )
        })}
      </Flex>
      <Image src={image} alt="image" width={['200px', '250px']} height={['200px', '250px']} />
    </VStack>
  )
}
